import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { HR_CATEGORIES, HR_ROLES, openDocument } from "@/lib/hr";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { RotateCcw, Eye } from "lucide-react";

export default function HRTrash() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/hrdoc/trash").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const restore = async (id) => {
    try {
      await api.post(`/hrdoc/documents/${id}/restore`);
      toast.success("Document hersteld");
      load();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return (
    <div className="space-y-6" data-testid="hr-trash">
      <div>
        <h1 className="text-3xl font-heading font-semibold">Prullenbak</h1>
        <p className="text-muted-foreground mt-1">Verwijderde documenten blijven bewaard en kunnen worden hersteld.</p>
      </div>
      <Card><CardContent className="p-5">
        <Table>
          <TableHeader><TableRow><TableHead>Werknemer</TableHead><TableHead>Categorie</TableHead><TableHead>Type</TableHead><TableHead>Periode</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((d) => (
              <TableRow key={d.id} data-testid={`hr-trash-${d.id}`}>
                <TableCell className="font-medium">{d.employee_name || "—"}</TableCell>
                <TableCell>{HR_CATEGORIES[d.category]}</TableCell>
                <TableCell>{HR_ROLES[d.document_role]}</TableCell>
                <TableCell>{d.period_key || "—"}</TableCell>
                <TableCell className="text-right space-x-1">
                  <Button size="icon" variant="ghost" onClick={() => openDocument(d.id)}><Eye className="h-4 w-4" /></Button>
                  <Button size="sm" variant="outline" data-testid={`hr-restore-${d.id}`} onClick={() => restore(d.id)}><RotateCcw className="h-4 w-4 mr-1" /> Herstellen</Button>
                </TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-8">De prullenbak is leeg.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
